import { weatherMachineChapters } from './content';
export const weatherMachineFaq = weatherMachineChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('FAQ'));
